// extracted by mini-css-extract-plugin
export default {"main-header":"MainHeader_main-header__qLz0V","main-header-inner":"MainHeader_main-header-inner__wXtFC"};